<section>
  <div id="slider">
    <div id="headerSlider" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img src="../assets/images/banner1.jpg" class="d-block w-100" />
          <div class="carousel-caption">
            <div class="banner-text">
              <h2>Privacy Policy</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="privacy_policy">
  <div class="site-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="privacy-content">
            <h1>Stride Real Estate – Privacy Policy</h1>
            
            <p>
              The following outlines the Privacy Policy of Stride Real Estate ("Stride"). This policy is established to clearly explain how personal information is handled, safeguarded, and processed when individuals access Stride's website, use its services, communicate with the team, or engage with any digital tools connected to Stride. By interacting with the website or providing information, users acknowledge and accept the practices described in this Privacy Policy.
            </p>

            <h2>1. Information Stride Collects</h2>
            
            <p>
              "Personal Information" refers to data that identifies or can be used to identify an individual. The type of information collected depends on how users interact with Stride Real Estate.
            </p>

            <h3>A. Website Visitors</h3>
            
            <p>Stride collects the following information automatically when users browse the website:</p>
            <ul>
              <li>Device details such as IP address, browser type, and operating system</li>
              <li>Usage analytics including page visits, time spent, and navigation patterns</li>
              <li>Approximate location based on IP address</li>
              <li>Cookies and tracking technologies for performance, personalization, and security</li>
            </ul>

            <h3>B. Individuals Contacting Stride</h3>
            
            <p>When users fill inquiry forms or request information, Stride collects:</p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Inquiry or message details</li>
            </ul>

            <h3>C. Clients Engaging in Real Estate Services</h3>
            
            <p>During buying, selling, renting, or investing processes, Stride collects:</p>
            <ul>
              <li>Identity details such as name and address</li>
              <li>Property-related documents including listing information, contracts, and disclosures</li>
              <li>Financial documents such as pre-approval letters or proof of funds</li>
              <li>Communication records including emails or call logs</li>
              <li>Scheduling information such as tour dates and showing appointments</li>
            </ul>

            <h3>D. Events & In-Person Meetings</h3>
            
            <p>When users attend open houses, meetings, or Stride-hosted events, Stride may collect:</p>
            <ul>
              <li>Registration information</li>
              <li>Contact details</li>
              <li>Optional preference information</li>
            </ul>

            <h2>2. How Stride Uses Personal Information</h2>
            
            <p>Stride uses collected information to:</p>
            <ul>
              <li>Provide real estate services and property-related assistance</li>
              <li>Communicate regarding inquiries, listings, tours, and transactions</li>
              <li>Send confirmations, updates, reminders, or alerts</li>
              <li>Facilitate property showings, negotiations, offers, and closings</li>
              <li>Enhance website functionality and user experience</li>
              <li>Personalize property recommendations</li>
              <li>Conduct analytics and performance monitoring</li>
              <li>Meet legal and regulatory requirements under Texas real estate laws</li>
              <li>Detect and prevent fraudulent or unauthorized activities</li>
            </ul>

            <p><strong>Stride does not sell Personal Information.</strong></p>

            <h2>3. Information Stride May Share</h2>
            
            <p>Stride shares Personal Information only in specific situations:</p>

            <h3>A. Service Providers & Business Partners</h3>
            
            <p>Stride may share information with trusted third parties who support:</p>
            <ul>
              <li>Real estate transactions</li>
              <li>Title and escrow activities</li>
              <li>Mortgage or lending processes (upon user request)</li>
              <li>Inspections, photography, or property services</li>
              <li>Marketing, analytics, and communication</li>
            </ul>

            <h3>B. Legal or Regulatory Requirements</h3>
            
            <p>Stride may disclose Personal Information when required to:</p>
            <ul>
              <li>Comply with state or federal real estate laws</li>
              <li>Respond to legal processes or law enforcement requests</li>
              <li>Protect the rights, security, or property of clients or Stride</li>
            </ul>

            <h3>C. With User Consent</h3>
            
            <p>Any additional sharing occurs only with explicit permission from the user.</p>

            <h2>4. User Privacy Choices</h2>
            
            <p>Users may:</p>
            <ul>
              <li>Unsubscribe from marketing communications</li>
              <li>Request updates or corrections to Personal Information</li>
              <li>Control cookie settings through their browser</li>
              <li>Request access or deletion of Personal Information (subject to legal retention obligations)</li>
            </ul>

            <h2>5. Privacy Rights Under U.S. State Laws</h2>
            
            <p>Depending on the state of residence, users may have rights to:</p>
            <ul>
              <li>Know what data is collected</li>
              <li>Request deletion of personal data</li>
              <li>Request access to data</li>
              <li>Opt out of certain data-sharing activities</li>
              <li>Request data portability</li>
            </ul>

            <h2>6. Retention of Personal Information</h2>
            
            <p>Stride retains information only as long as necessary for:</p>
            <ul>
              <li>Real estate processes</li>
              <li>Legal and regulatory requirements</li>
              <li>Recordkeeping</li>
              <li>Dispute resolution</li>
            </ul>

            <p>After retention periods expire, data is securely deleted or anonymized.</p>

            <h2>7. Data Security</h2>
            
            <p>
              Stride uses industry-standard administrative and technical safeguards. However, no system is completely secure. Users are encouraged to use strong passwords and report suspicious activity.
            </p>

            <h2>8. Third-Party Links</h2>
            
            <p>
              The website may include external links. Stride is not responsible for third-party privacy practices, and users should review external policies independently.
            </p>

            <h2>9. Children's Privacy</h2>
            
            <p>
              Stride Real Estate does not knowingly collect information from individuals under the age of 18.
            </p>

            <h2>10. Policy Updates</h2>
            
            <p>
              Stride may update this Privacy Policy periodically. Updated versions will be posted on the website.
            </p>

            <h2>11. Contact Information</h2>
            
            <p>
              <strong>Stride Real Estate</strong><br>
              626 Westwind Dr, Allen, TX, 75002<br>
              <a href="mailto:info@stridere.com">info@stridere.com</a><br>
              <a href="tel:4696618966">469-661-8966</a><br>
              <a href="https://www.striderealestate.com" target="_blank">www.striderealestate.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

